module.exports = __webpack_public_path__ + "img/par_nos_soins.6dfe076f.png";